import Box from '@mui/material/Box';
import React from 'react';

import { StatusBadgeProps } from './StatusBadge.props';
import { COLORS } from '../../../configs/colors';

interface StatusColors {
  bg: string;
  text: string;
}

const getStatusColors = (status: string): StatusColors => {
  const lower = status.toLowerCase();

  if (lower.includes('in progress')) {
    return { bg: COLORS.StatusInProgressBg, text: COLORS.StatusInProgressText };
  }
  if (lower.includes('open')) {
    return { bg: COLORS.StatusOpenBg, text: COLORS.StatusOpenText };
  }
  if (lower.includes('pending')) {
    return { bg: COLORS.StatusPendingPartsBg, text: COLORS.StatusPendingPartsText };
  }
  if (lower.includes('scheduled')) {
    return { bg: COLORS.StatusScheduledBg, text: COLORS.StatusScheduledText };
  }
  if (lower.includes('closed') || lower.includes('completed')) {
    return { bg: COLORS.StatusClosedBg, text: COLORS.StatusClosedText };
  }
  if (lower.includes('cancelled')) {
    return { bg: COLORS.StatusCancelledBg, text: COLORS.StatusCancelledText };
  }

  return { bg: COLORS.StatusDefaultBg, text: COLORS.StatusDefaultText };
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'default',
}) => {
  const colors = getStatusColors(status);

  return (
    <Box
      component="span"
      role="status"
      aria-label={`Status: ${status}`}
      sx={{
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: 2,
        fontSize: size === 'small' ? '10px' : '11px',
        fontWeight: 600,
        bgcolor: colors.bg,
        color: colors.text,
      }}
    >
      {status}
    </Box>
  );
};
